<template>
  <div v-if="store.state.base.responsive.isMD">
    <!-- スマホ画面用バナー -->
    <!-- メンタルノイズ・ウェルフーチャー以外のバナーを表示 -->
    <template v-if="show_oneday_240225oneday">
      <a href="https://saipon.jp/h/xme885" target="_blank">
        <img loading="lazy" src="@/assets/images/banner/oneday_240225oneday/sp.png" alt="thumbnail" class="w-full hover:opacity-75 cursor-pointer my-2">
      </a>
    </template>
    <template v-if="!is_mentalnc_main && !is_mentalnc_main_new">
      <!-- メンタルノイズロールを所持していない人向けバナー -->
      <a href="https://mentalnc.com/noisecanceling/sl/SN2g" target="_blank">
        <img loading="lazy" src="@/assets/images/banner/mentalnc/sp.jpg" alt="thumbnail" class="w-full hover:opacity-75 cursor-pointer my-1">
      </a>
    </template>
    <template v-else>
      <template v-if="!is_wellfuture && left_days > 0">
        <!-- メンタルノイズ加入後21日間はウェルフーチャーバナーを表示 -->
        <div class="message text-xl">募集締め切りまで、あと{{ left_days }}日</div>
        <a href="https://mentalnc.com/wellfuture/4lqDh7" target="_blank">
          <img loading="lazy" src="@/assets/images/banner/wellfuture/sp.png" alt="thumbnail" class="w-full hover:opacity-75 cursor-pointer my-1">
        </a>
      </template>
      <template v-else>
      </template>
    </template>
  </div>
  <div v-else>
    <template v-if="show_oneday_240225oneday">
      <a href="https://saipon.jp/h/xme885" target="_blank">
        <img loading="lazy" src="@/assets/images/banner/oneday_240225oneday/pc.png" alt="thumbnail" class="w-full hover:opacity-75 cursor-pointer my-2">
      </a>
    </template>
    <!-- PC画面用バナー -->
    <template v-if="!is_mentalnc_main && !is_mentalnc_main_new">
      <!-- メンタルノイズロールを所持していない人向けバナー -->
      <a href="https://mentalnc.com/noisecanceling/sl/SN2g" target="_blank">
        <img loading="lazy" src="@/assets/images/banner/mentalnc/pc.jpg" alt="thumbnail" class="w-full hover:opacity-75 cursor-pointer my-1">
      </a>
    </template>
    <template v-else>
      <template v-if="!is_wellfuture && left_days > 0">
        <!-- メンタルノイズ加入後21日間はウェルフーチャーバナーを表示 -->
        <div class="message text-3xl">募集締め切りまで、あと{{ left_days }}日</div>
        <a href="https://mentalnc.com/wellfuture/4lqDh7" target="_blank">
          <img loading="lazy" src="@/assets/images/banner/wellfuture/pc.png" alt="thumbnail" class="w-full hover:opacity-75 cursor-pointer my-1">
        </a>
      </template>
      <template v-else>
      </template>
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useStore } from '@/store/index'
import { RoleAttributes } from '@/types/models/role'
import dayjs from 'dayjs'

export default defineComponent({
  components: {
  },
  setup() {
    const store = useStore()
    const is_mentalnc_main = ref()
    const is_mentalnc_main_new = ref()
    const is_wellfuture = ref()
    const is_unki = ref()
    const is_welldream = ref()
    // const is_ningenkankei = ref()
    // const is_seikouhousoku = ref()
    // const is_wellstream03 = ref(false)
    // const is_wellstream03_no = ref(false)
    // const is_wellstream03_noican = ref(false)
    // const is_wellstream03_well = ref(false)
    const is_oneday_240225oneday = ref(false)
    // const show_ningenkankei = ref()
    // const show_seikouhousoku = ref()
    // const show_wellstream03_no = ref(false)
    // const show_wellstream03_noican = ref(false)
    // const show_wellstream03_well = ref(false)
    const show_oneday_240225oneday = ref(false)
    const left_days = ref()
    const now_date = ref(dayjs(new Date()))
    // const END_NINGENKANKEI = dayjs('2023-07-31 23:59:59')
    // const START_SEIKOUHOUSOKU = dayjs('2023-09-01 00:00:00')
    // const END_SEIKOUHOUSOKU = dayjs('2023-09-30 23:59:59')
    // const show_welldream = ref(false)
    // const START_WELLSTREAM03 = dayjs('2023-11-01 00:00:00')
    // const END_WELLSTREAM03 = dayjs('2023-11-10 23:59:59')
    // const START_UNKI_202401 = dayjs('2024-01-01 00:00:00')
    // const END_UNKI_202401 = dayjs('2024-01-31 23:59:59')
    const START_ONEDAY_240225 = dayjs('2024-02-01 00:00:00')
    const END_ONEDAY_240225 = dayjs('2024-02-20 23:59:59')

    // const showUnki202401 = computed(() => {
    //   return (START_UNKI_202401 < now_date.value && now_date.value < END_UNKI_202401 && !is_unki.value)
    // })

    // const requiredRoles_no = ['wellstream02', 'yousei_jitsugi', 'yousei_online', 'welllabo_cancel', 'well_labo', 'wellmyself', 'mentalnc_new', 'mentalnc_main', 'wellfuture', 'wellstream', 'yousei_group02', 'welldream', 'yousei_online03', 'yousei_jitsugi03', 'wellstream03', 'yousei_jitsugi02']
    // const requiredRoles_noican = ['noican_future_notwell', 'noicannew_notwell', 'future_notwell']
    // const requiredRoles_well = ['wellstream', 'wellmyself', 'well_labo', 'welllabo_cancel', 'yousei_online', 'yousei_jitsugi', 'wellstream02', 'yousei_online02', 'yousei_jitsugi02', 'yousei_group02', 'welldream', 'yousei_online03', 'yousei_jitsugi03']

    // const not_noican_not_well = [
    //   { slug: 'wellstream02', include: 0 },
    //   { slug: 'yousei_jitsugi', include: 0 },
    //   { slug: 'yousei_online', include: 0 },
    //   { slug: 'welllabo_cancel', include: 0 },
    //   { slug: 'well_labo', include: 0 },
    //   { slug: 'wellmyself', include: 0 },
    //   { slug: 'mentalnc_new', include: 0 },
    //   { slug: 'mentalnc_main', include: 0 },
    //   { slug: 'wellfuture', include: 0 },
    //   { slug: 'wellstream', include: 0 },
    //   { slug: 'yousei_group02', include: 0 },
    //   { slug: 'welldream', include: 0 },
    //   { slug: 'yousei_online03', include: 0 },
    //   { slug: 'yousei_jitsugi03', include: 0 },
    //   { slug: 'wellstream03', include: 0 },
    //   { slug: 'yousei_jitsugi02', include: 0 }
    // ]

    // const noican_future_notwell = [
    //   { slug: 'mentalnc_main', include: 1 },
    //   { slug: 'wellstream', include: 0 },
    //   { slug: 'wellmyself', include: 0 },
    //   { slug: 'well_labo', include: 0 },
    //   { slug: 'welllabo_cancel', include: 0 },
    //   { slug: 'yousei_online', include: 0 },
    //   { slug: 'yousei_jitsugi', include: 0 },
    //   { slug: 'wellstream02', include: 0 },
    //   { slug: 'yousei_online02', include: 0 },
    //   { slug: 'yousei_jitsugi02', include: 0 },
    //   { slug: 'yousei_group02', include: 0 },
    //   { slug: 'welldream', include: 0 },
    //   { slug: 'yousei_online03', include: 0 },
    //   { slug: 'yousei_jitsugi03', include: 0 },
    //   { slug: 'wellstream03', include: 0 }
    // ]

    // const noicannew_notwell = [
    //   { slug: 'yousei_group02', include: 0 },
    //   { slug: 'mentalnc_new', include: 1 },
    //   { slug: 'wellstream', include: 0 },
    //   { slug: 'wellmyself', include: 0 },
    //   { slug: 'well_labo', include: 0 },
    //   { slug: 'welllabo_cancel', include: 0 },
    //   { slug: 'yousei_online', include: 0 },
    //   { slug: 'yousei_jitsugi', include: 0 },
    //   { slug: 'yousei_online02', include: 0 },
    //   { slug: 'yousei_jitsugi02', include: 0 },
    //   { slug: 'wellstream02', include: 0 },
    //   { slug: 'welldream', include: 0 },
    //   { slug: 'yousei_online03', include: 0 },
    //   { slug: 'yousei_jitsugi03', include: 0 },
    //   { slug: 'wellstream03', include: 0 }
    // ]

    // const future_notwell = [
    //   { slug: 'welldream', include: 0 },
    //   { slug: 'wellfuture', include: 1 },
    //   { slug: 'wellstream03', include: 0 },
    //   { slug: 'yousei_jitsugi03', include: 0 },
    //   { slug: 'yousei_online03', include: 0 },
    //   { slug: 'yousei_group02', include: 0 },
    //   { slug: 'yousei_jitsugi02', include: 0 },
    //   { slug: 'yousei_online02', include: 0 },
    //   { slug: 'wellstream02', include: 0 },
    //   { slug: 'yousei_jitsugi', include: 0 },
    //   { slug: 'yousei_online', include: 0 },
    //   { slug: 'welllabo_cancel', include: 0 },
    //   { slug: 'well_labo', include: 0 },
    //   { slug: 'wellmyself', include: 0 },
    //   { slug: 'wellstream', include: 0 }
    // ]

    onMounted(() => {
      is_mentalnc_main.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'mentalnc_main')
      is_mentalnc_main_new.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'mentalnc_new')
      is_wellfuture.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'wellfuture')
      is_unki.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'unki')
      is_welldream.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'welldream')
      // is_wellstream03.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'wellstream03')
      is_oneday_240225oneday.value = store.state.user.user.roles.find((role:RoleAttributes) => role.slug === 'oneday_240225oneday')

      // is_wellstream03_no.value = checkAnyRoleCondition(store.state.user.user.roles, [not_noican_not_well])
      // is_wellstream03_noican.value = checkAnyRoleCondition(store.state.user.user.roles, [noican_future_notwell, noicannew_notwell, future_notwell])
      // is_wellstream03_well.value = requiredRoles_well.some(requiredRoles_well =>
      //   store.state.user.user.roles.some((role:any) => role.slug === requiredRoles_well)
      // )

      if (is_mentalnc_main.value || is_mentalnc_main_new.value){
        if (is_mentalnc_main.value){
          let entry_date = dayjs(is_mentalnc_main.value.pivot.created_at)
          let end_date = entry_date.add(21, 'd')
          left_days.value = Number(end_date.diff(now_date.value, 'day'))
        } else if (is_mentalnc_main_new.value){
          let entry_date = dayjs(is_mentalnc_main_new.value.pivot.created_at)
          let end_date = entry_date.add(21, 'd')
          left_days.value = Number(end_date.diff(now_date.value, 'day'))
        }
      }

      //2023/7/31前の場合
      // if (now_date.value < END_NINGENKANKEI){
      //   //ウェルドリームロールを所持していない
      //   if (!is_ningenkankei.value){
      //     show_ningenkankei.value = true
      //   } 
      // }

      //2023/9/1~2023/9/30の場合、「間違いだらけの成功法則」バナー表示
      // if (START_SEIKOUHOUSOKU < now_date.value && now_date.value < END_SEIKOUHOUSOKU){
      //   //間違いだらけの成功法則を所持していない
      //   if (!is_seikouhousoku.value){
      //     show_seikouhousoku.value = true
      //   } 
      // }

      //2023/11/1~2023/11/11の場合、「ウェルストリーム」バナー表示
      // if (START_WELLSTREAM03 < now_date.value && now_date.value < END_WELLSTREAM03 && !is_wellstream03.value){
      //   //間違いだらけの成功法則を所持していない
      //   if (is_wellstream03_no.value){
      //     show_wellstream03_no.value = true
      //   }
      //   if (is_wellstream03_noican.value){
      //     show_wellstream03_noican.value = true
      //   } 
      //   if (is_wellstream03_well.value){
      //     show_wellstream03_well.value = true
      //   } 
      // }

      //2023/11/1~2023/11/11の場合、「ウェルストリーム」バナー表示
      if (START_ONEDAY_240225 < now_date.value && now_date.value < END_ONEDAY_240225 && !is_oneday_240225oneday.value){
        //間違いだらけの成功法則を所持していない
        if (!is_oneday_240225oneday.value){
          show_oneday_240225oneday.value = true
        }
      }
    })

    function checkRoles(userRoles:any, rolesConditions:any) {
      // `include: 1` のすべてのロールがユーザーのロールに含まれているか
      const includesAllRequired = rolesConditions
        .filter((condition:any) => condition.include === 1)
        .every((required:any) => userRoles.some((role:any) => role.slug === required.slug))

      // `include: 0` のロールがユーザーのロールに含まれていないか
      const includesNoExcluded = rolesConditions
        .filter((condition:any) => condition.include === 0)
        .every((excluded:any) => !userRoles.some((role:any) => role.slug === excluded.slug))

      return includesAllRequired && includesNoExcluded
    }

    function checkAnyRoleCondition(userRoles:any, rolesConditionsSets:any) {
      return rolesConditionsSets.some((rolesConditions:any) => checkRoles(userRoles, rolesConditions))
    }

    return {
      store,
      is_mentalnc_main,
      is_mentalnc_main_new,
      is_wellfuture,
      // show_ningenkankei,
      // show_seikouhousoku,
      left_days,
      // show_welldream,
      // show_wellstream03_no,
      // show_wellstream03_noican,
      // show_wellstream03_well,
      // showUnki202401,
      show_oneday_240225oneday,
    }
  }
})
</script>

<style scoped>
.message {
    color: #032c78;
    text-align:center;
}
</style>
